import * as React from "react";

import "./edit-form-field.scss";

import {Types} from "@Common/types";

import {DatePickerField}   from "./date-picker-field/date-picker-field";
import {DropdownField}     from "./dropdown-field/dropdown-field";
import {HiddenField}       from "./hidden-field/hidden-field";
import {OfficeSearchField} from "./office-search-field/office-search-field";
import {ReadOnlyField}     from "./read-only-field/read-only-field";
import {TextAreaField}     from "./text-area-field/text-area-field";
import {UserSearchField}   from "./user-search-field/user-search-field";

export const EditFormField = ({
    textField,
    cc,
    xdQaName                = null,
    allowSuggestedComments  = false,
    findTf                  = null,
    variableData            = null,
    itemId,
    isAPM                   = false,
}:{
    textField               : Types.Common.Tools.CcIntegration.Models.TextField,
    cc                      : Types.Common.Tools.CcIntegration.Models.CcEditor,
    xdQaName                : string,
    allowSuggestedComments  : boolean,
    findTf                 ?: (name:string) => Types.Common.Tools.CcIntegration.Models.TextField,
    variableData           ?: Types.Apis.Models.VariableData[],
    itemId                 ?: string|number,
    isAPM                  ?: boolean,
}) => {
    if (textField.locked === true) {
        return null;
    }
    const display = fieldDisplayByTypes[textField.type] ?? fieldDisplayByTypes["textArea"];
    if (display === fieldDisplayByTypes["textArea"]) {
        return display({textField, cc, xdQaName, allowSuggestedComments, findTf, variableData, itemId, isAPM});
    }
    return display({textField, cc, xdQaName, findTf, variableData});
}

const fieldDisplayByTypes = {
    textArea: TextAreaField,
    hidden: HiddenField,
    readOnly: ReadOnlyField,
    dropdown: DropdownField,
    officeSearch: OfficeSearchField,
    userSearch: UserSearchField,
    datePicker: DatePickerField,
};
